import axios from "axios";
import { getToken } from "./authenticationService";

axios.interceptors.request.use(
  async function (config) {
    try {
      const token = await getToken();
      config.headers.Authorization = `Bearer ${token}`;
    } catch (error) {
      console.error("Failed to add authorization header", error);
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

const axiosService = {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
  patch: axios.patch,
};
export default axiosService;
